import LocalFooter from '@jobseeker/lotus/components/Footer';
import SeoFooter from '@jobseeker/lotus/components/SeoFooter';
import BaseFooter from '@jobseeker/lotus/components/BaseFooter';

import type {Props as FooterProps} from '@jobseeker/lotus/components/Footer/types';

const Footer = (props: FooterProps) => {
  if (props?.page === 'home') {
    return <LocalFooter {...props} />;
  }

  if (props?.page.includes('registration-')) {
    return;
  }

  if (props?.page.indexOf('epoch') > -1) {
    return <BaseFooter {...props} />;
  }

  if (
    !['home', 'personalize-jobfeed'].includes(props?.page) &&
    props?.tabsList?.length > 0
  ) {
    return <SeoFooter {...props} />;
  }
};

export default Footer;
